import { CalendarItem } from '@/services/calendarApi';

export type EventType = CalendarItem['type'];

// Canonical display order for the six event types.
export const EVENT_TYPES: EventType[] = [
  'training',
  'match',
  'medical',
  'meeting',
  'travel',
  'other',
];

// Human-readable labels for each type.
export const EVENT_TYPE_LABELS: Record<EventType, string> = {
  training: 'Training',
  match: 'Match',
  medical: 'Medical',
  meeting: 'Meeting',
  travel: 'Travel',
  other: 'Other',
};

// Background colour class for each type (source of truth for the grid + filters).
export const EVENT_TYPE_COLOR: Record<EventType, string> = {
  training: 'bg-blue-600',
  match: 'bg-red-600',
  medical: 'bg-green-600',
  meeting: 'bg-purple-600',
  travel: 'bg-purple-600',
  other: 'bg-gray-500',
};
